import React, { useState } from "react";
import { Box, Flex, Button, Text, Icon, useColorModeValue } from "@chakra-ui/react";
import { Download, Upload, FileText } from "lucide-react";
import axios from "axios";
import Card from "components/card/Card.js";
import Formfield from "views/global/field";
import SimpleUpload from "views/global/SimpleUpload";
import { QuickAlert } from "theme/components/alerts";
import { userController } from "lib/user";

export default function LaundrySettings() {
    const { setAlert, clearAlert, showAlert } = QuickAlert();
    const { attachmentUpload } = userController();
    const headerBorderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");

    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [file, setFile] = useState(null);

    const handleUpload = (accepted, rejected) => {
        if (rejected.length > 0) {
            setAlert("error", "File non valido. Carica un file .xlsx, .xls o .csv.");
            return;
        }
        if (accepted.length > 0) {
            setFile(accepted[0]);
            clearAlert();
        }
    };

    const handleUpdate = () => {
        if (!file) return;
        setLoading(true);
        clearAlert();
        const formData = new FormData();
        formData.append("file", file);
        attachmentUpload("/user/laundry/update", formData)
            .then(response => {
                setAlert(response.data.type, response.data.message);
                setLoading(false);
                setFile(null);
            })
            .catch(error => {
                setAlert("error", error.response.data.errors);
                setLoading(false);
            });
    };

    const handleDownload = () => {
        setDownloading(true);
        const token = JSON.parse(localStorage.getItem("token"));
        axios.get(process.env.REACT_APP_API + "/user/laundry/download", {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob",
        })
        .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            const contentDisposition = response.headers["content-disposition"];
            let filename = "laundry-options.xlsx";
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match) filename = match[1];
            }
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            setDownloading(false);
        })
        .catch(error => {
            setAlert("error", error.response.data.errors);
            setDownloading(false);
        });
    };

    return (
        <Box>
            <Card mb="20px" p="0">
                <Flex justify="space-between" align="center" pt="20px" pb="16px" px="24px" borderBottom="1px solid" borderColor={headerBorderColor}>
                    <Text color="secondaryGray.900" fontSize="22px" fontWeight="700" lineHeight="100%">
                        Opzioni Biancheria
                    </Text>
                    <Button
                        variant="outline"
                        colorScheme="brand"
                        fontWeight="light"
                        leftIcon={<Download />}
                        isLoading={downloading}
                        onClick={handleDownload}
                    >
                        Scarica Opzioni Biancheria
                    </Button>
                </Flex>
                <Box px="24px" pt="20px" pb="24px">
                {showAlert()}
                <Formfield label="Importa Opzioni Biancheria" required="true">
                    <SimpleUpload
                        w="100%"
                        minH="150px"
                        mb={file ? 4 : 0}
                        params={{ accept: ".xlsx,.xls,.csv", multiple: false }}
                        content={
                            file ? (
                                <Flex align="center" direction="column">
                                    <Icon as={FileText} w="36px" h="36px" color="brand.600" />
                                    <Text fontSize="sm" fontWeight="600" color="brand.600" mt={2}>
                                        {file.name}
                                    </Text>
                                    <Text fontSize="xs" color="secondaryGray.500" mt={1}>
                                        Clicca o trascina per sostituire
                                    </Text>
                                </Flex>
                            ) : (
                                <Box textAlign="center">
                                    <Icon as={Upload} w="42px" h="42px" color="brand.600" />
                                    <Flex justify="center" mx="auto" mb="4px">
                                        <Text fontSize="lg" fontWeight="700" color="brand.600">
                                            Carica File
                                        </Text>
                                    </Flex>
                                    <Text fontSize="sm" fontWeight="500" color="secondaryGray.500">
                                        .xlsx, .xls o .csv
                                    </Text>
                                </Box>
                            )
                        }
                        onUpload={handleUpload}
                    />
                </Formfield>
                </Box>
                <Flex align="center" pt="16px" pb="16px" px="24px" borderTop="1px solid" borderColor={headerBorderColor}>
                    <Button
                        isLoading={loading}
                        variant="brand"
                        minWidth="150px"
                        onClick={handleUpdate}
                        isDisabled={!file}
                    >
                        Aggiorna
                    </Button>
                </Flex>
            </Card>
        </Box>
    );
}
